import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import {
  LOAD,
  LOAD_END,
} from "../../../../../../../store/actions/actionsTypes";
import { handleNotifications } from "../../../../../../generic/utils/handleNotifications";
import { IKavDataItem } from "../../../../../../modules/API/Drivers/models/kavData";
import { TEUDOT_PROBLEMS } from "../../../../../../modules/API/TeudotProblems/teudotProblems";
import type { ISelectedProblem } from "../../DriversMain";
import { applyProblemStatus } from "../../helpers/driversState";

export interface IUseTeudotProblems {
  selectedProblem: ISelectedProblem | null;
  isOpenProblemModal: boolean;
  handleIsOpenProblemModal: () => void;
  handleSelectProblem: (customerItem: ISelectedProblem) => void;
  handleProblem: (problemID: number, status: number) => Promise<void>;
  problemModalProps: {
    handleProblem: (problemID: number, status: number) => Promise<void>;
    selectedProblem: ISelectedProblem | null;
  };
}

export const useTeudotProblems = (deps: {
  setData: React.Dispatch<React.SetStateAction<IKavDataItem[] | null>>;
}): IUseTeudotProblems => {
  const { setData } = deps;
  const dispatch = useDispatch();
  const [selectedProblem, setSelectedProblem] =
    useState<ISelectedProblem | null>(null);
  const [isOpenProblemModal, setIsOpenProblemModal] = useState(false);

  const handleIsOpenProblemModal = useCallback(() => {
    setIsOpenProblemModal((prev) => !prev);
  }, []);

  const handleSelectProblem = useCallback((customerItem: ISelectedProblem) => {
    setSelectedProblem({
      kavID: customerItem.kavID,
      CustomerID: customerItem.CustomerID,
      item: customerItem.item,
    });
    setIsOpenProblemModal(true);
  }, []);

  const handleProblem = useCallback(
    async (problemID: number, status: number) => {
      if (!selectedProblem) return;
      dispatch({ type: LOAD });
      try {
        await TEUDOT_PROBLEMS.approveProblemForDriver(problemID, status);
        handleNotifications("פניה נטפלה בהצלחה", { type: "success" });
        setData((prev) =>
          prev ? applyProblemStatus(prev, selectedProblem.kavID, problemID, status) : prev
        );
        setSelectedProblem((prev) =>
          prev
            ? {
                ...prev,
                item: prev.item.map((e) =>
                  e.OrderID === problemID ? { ...e, DriverStatus: status } : e
                ),
              }
            : null
        );
      } catch (err) {
        handleNotifications("אירעה שגיאה בעת טיפול בפניה", { type: "error" });
      } finally {
        dispatch({ type: LOAD_END });
      }
    },
    [dispatch, selectedProblem, setData]
  );

  return {
    selectedProblem,
    isOpenProblemModal,
    handleIsOpenProblemModal,
    handleSelectProblem,
    handleProblem,
    problemModalProps: { handleProblem, selectedProblem },
  };
};

export default useTeudotProblems;
